import { render, staticRenderFns } from "./safetyInspectionRecords.vue?vue&type=template&id=0ea8bf4d&scoped=true&"
import script from "./safetyInspectionRecords.vue?vue&type=script&lang=js&"
export * from "./safetyInspectionRecords.vue?vue&type=script&lang=js&"
import style0 from "./safetyInspectionRecords.vue?vue&type=style&index=0&id=0ea8bf4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8bf4d",
  null
  
)

export default component.exports